export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyCG49duPtl9FBtADG0pZjA5wDsN6ry7UFY';

/**
 * Builds the official Google Maps Embed URL with the corporate API key.
 * If no key is configured, falls back to the legacy embed URL.
 *
 * @param {number} lat Latitude
 * @param {number} lon Longitude
 * @param {number} zoom Zoom level (default 15)
 * @returns {string} Embed URL
 */
export const getGoogleMapsEmbedUrl = (lat, lon, zoom = 15) => {
  if (GOOGLE_MAPS_API_KEY) {
    return `https://www.google.com/maps/embed/v1/place?key=${encodeURIComponent(GOOGLE_MAPS_API_KEY)}&q=${lat},${lon}&zoom=${zoom}&language=es`;
  }
  return `https://maps.google.com/maps?q=${lat},${lon}&hl=es&z=${zoom}&output=embed`;
};

/**
 * Builds the external Google Maps web link.
 *
 * @param {number} lat Latitude
 * @param {number} lon Longitude
 * @returns {string} External Google Maps URL
 */
export const getGoogleMapsExternalUrl = (lat, lon) => {
  return `https://www.google.com/maps?q=${lat},${lon}`;
};

